'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PracticeSpecialtiesSection = function PracticeSpecialtiesSection(props) {
    var specialties = props.specialties,
        active = props.active;

    return _react2.default.createElement(
        'div',
        { className: (active ? _style2.default.activePracticeSection : '') + ' ' + _style2.default.specialtiesContainer },
        _react2.default.createElement(
            'h2',
            null,
            'Specialties'
        ),
        _react2.default.createElement(
            'div',
            { className: _style2.default.textBlock },
            specialties.map(function (item, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index, className: _style2.default.practiceSpecialties },
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement('img', { src: item.img }),
                        _react2.default.createElement(
                            'span',
                            null,
                            item.name
                        )
                    )
                );
            })
        )
    );
};

PracticeSpecialtiesSection.propTypes = {
    specialties: require('react').PropTypes.arrayOf(require('react').PropTypes.shape({
        img: require('react').PropTypes.string,
        name: require('react').PropTypes.string
    })),
    active: require('react').PropTypes.bool.isRequired
};
PracticeSpecialtiesSection.displayName = 'PracticeSpecialtiesSection';

PracticeSpecialtiesSection.defaultProps = {
    articles: []
};

exports.default = (0, _reactIntl.injectIntl)(PracticeSpecialtiesSection);


// WEBPACK FOOTER //
// ./components/profile-right-section/lib/components/practice-specialties-section.js